"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { label: "HOME", href: "#", active: true },
    { label: "PROJECTS", href: "#portifolio", active: false },
    { label: "FQAs", href: "#realme", active: false },
  ];

  return (
    <header className="w-full px-4 sm:px-6 lg:px-8 py-2 sticky top-1 z-[100]">
      <div className="flex justify-between items-center bg-secondary/20 backdrop-blur-md rounded-[26px] px-3 py-3 sm:px-4 sm:py-3 md:px-6 md:py-4 relative">
        {/* Logo Section */}
        <div className="flex items-center gap-2">
          <Image
            src="/images/img_group_1.svg"
            alt="Porta Logo"
            width={22}
            height={22}
            className="w-5 h-5 sm:w-6 sm:h-6"
          />
          <h1 className="text-foreground  font-medium text-lg sm:text-xl md:text-2xl lg:text-[26px] leading-8">
            Fiacre Engineer
          </h1>
        </div>

        {/* Hamburger Menu Icon (Mobile only) */}
        <button
          className="block lg:hidden p-2 text-foreground"
          aria-label="Open menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>

        {/* Navigation Menu */}
        <nav
          className={`
          ${menuOpen ? "block" : "hidden"} 
          lg:block 
          absolute lg:relative 
          top-full lg:top-auto 
          left-0 lg:left-auto 
          w-full lg:w-auto 
          bg-secondary lg:bg-transparent 
          mt-2 lg:mt-0 
          rounded-lg lg:rounded-none 
          p-4 lg:p-0 
          z-50
        `}
        >
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-6">
            {menuItems.map((item, index) => (
              <Link
                key={index}
                href={item.href}
                className={` font-normal text-sm sm:text-base transition-colors duration-200 hover:text-foreground ${
                  item.active ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
